import { useMemo, useEffect } from 'react';
export const IressReactRouterHashLinks = (props) => {
    const hashElement = useMemo(() => {
        const hash = props.location.hash;
        if (!hash)
            return null;
        const parts = hash.split('#');
        return document.getElementById(parts[parts.length - 1]);
    }, [props.location]);
    useEffect(() => {
        if (hashElement) {
            hashElement.scrollIntoView(props.scrollIntoViewOptions || {
                behavior: 'smooth',
                inline: 'nearest',
            });
            if (document.activeElement !== hashElement) {
                if (!hashElement.hasAttribute('tabindex'))
                    hashElement.setAttribute('tabindex', '-1');
                hashElement.focus({ preventScroll: true });
            }
        }
    }, [hashElement, props]);
    return null;
};
//# sourceMappingURL=IressReactRouterHashLinks.js.map